import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';
import { Claims } from '../../types/permissions/Claims';
import { permissionsService } from '../../utils/PermissionService';

/**
 * Returns a boolean value for whether the user has permission to the supplied claims.
 * Prefer to use the <Permissive> wrapper to protect DOM elements, but this hook may
 * be used independently in case a permission check needs to be run programmatically.
 * @param permissionsToCheck 
 */
export function usePermissionCheck(permissionsToCheck: readonly Claims[]): boolean {
    const account = useWolfTracsState(s => s.account);

    // Note: The runtime not-null checks below are important. This hook gets called by
    // the <Permissive> wrapper, which is called in hundreds of places NOT protected by TypeScript.

    // Case 1: A permissive wrapper with no permissions inside of it - ALLOW (this is equivalent to no permissive wrapper)
    // Note: I feel like this shouldn't be allowed, but it's hard to enforce at this point. Maybe circle back eventually.
    if(!permissionsToCheck || permissionsToCheck.length === 0) {
        return true;
    }

    // Now we know permissions are requested to be checked against.

    // Therefore: If the user's account is not yet loaded, or we don't have any information
    // about the account's permissions, BLOCK access to the nested component.
    if(!account || !account.permissions) {
        return false;
    }

    // Run the permission check through the independent permission checker.
    const hasPermissionResult = permissionsService.hasPermissions(account.permissions, permissionsToCheck);

    return hasPermissionResult;  
}